import { Module } from '@nestjs/common';
import { ScheduleModule } from '@nestjs/schedule';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import appSettings from 'apps/services/config';
import { EnquiriesEntity } from './enquiries/entites/enquiries';
import { EnquiryProdctsEntity } from './enquiries/entites/enquiry-products';
import { EnquiriesModule } from './enquiries/enquiry.module';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { EnquiryLogEntity } from './enquiries/entites/enquiry-log';
import { CostSheetModule } from './costing/costing.module';
import { CostSheetEntity } from './costing/entity/cost-sheet-entity';
import { MFGCostsEntity } from './costing/entity/mfg-costs-entity';
import { FreightForwardExpensesEntity } from './costing/entity/freight-forward-expenses-entity';
import { EnquiryPackBomEntity } from './enquiries/entites/enquiry-pack-bom.entity';

@Module({
  imports: [
    ScheduleModule.forRoot(),
    TypeOrmModule.forRoot({
      type: 'mysql',
      // host: '142.93.219.119',
      host: appSettings.dbhost,
      port: 3306,
      username: appSettings.dbuser,
      password: appSettings.dbpassword,
      database: appSettings.enquiry_db,
      entities: [EnquiriesEntity,EnquiryProdctsEntity,EnquiryLogEntity,CostSheetEntity,MFGCostsEntity,FreightForwardExpensesEntity,EnquiryPackBomEntity],
      synchronize: false,
      logging: true
    }),
    EnquiriesModule,
    CostSheetModule
  ],
  controllers: [AppController],
  providers: [AppService,ApplicationExceptionHandler],
})
export class AppModule {}


